import React from 'react'
import { AdminTable } from "./Components"

const Admin = () => {
  return (
    <div>
      <AdminTable />
    </div>
  )
}

export default Admin